const projects = [
  {
    name: "Ethnic Artisans",
    link: "https://ethnicartisans.netlify.app/",
    description:
      "Ethnic Arisans, a handmade jewellery ecommerce platform, where you can explore variety of handmade jewelleries in a very affordable price. It is a live freelancing project. The website was made according to the client demand.",
    tech:
      "Bootstrap, CSS, JavaScript in the frontend, Node JS and Express JS in the backend (in progress), MongoDB as database (in progress).",
    year: "2024 - Present",
  },
  {
    name: "SocioCube - chatting and video calling website",
    link: "https://sociocube.netlify.app/",
    description:
      "SocioCube, a chatting and video calling platform where you can interact with anonymous persons. You can socialize yourself.",
    tech:
      "React JS in the frontend, Node JS and Express JS in the backend, MongoDB as database and other helping technologies i.e. Socket.io.",
    year: "2023",
  },
  {
    name: "FileSwift - Share and Transfer Files with Ease",
    link: "https://fileswift.netlify.app/",
    description:
      "FileSwift - Effortless File Sharing and Transfer Platform. Share Files Securely, transparently, conviniently with Custom Links.",
    tech: "React JS in the frontend, Node JS and Express JS in the backend, MongoDB as database.",
    year: "2023",
  },
  {
    name: "SnapNoteBook - Your personal diary | Notebook",
    link: "https://snapnotebook.netlify.app/",
    description:
      "SnapNoteBook, your personal online diary and note storage solution. At SnapNoteBook, we understand the importance of keeping your thoughts, ideas, and to-dos organized in one secure and accessible place.",
    tech:
      "React JS and Bootstrap in the frontend, Node JS and Express JS in the backend, MongoDB as database.",
    year: "2023",
  },
  {
    name: "ManiText - Text utility platform",
    link: "https://manitext.netlify.app/",
    description:
      "ManiText, your go-to destination for all your text manipulation needs. Whether you're a writer, student, or just someone looking to make your text work for you, we've got you covered. Our user-friendly online text manipulation tools are designed to simplify and enhance your text-related tasks.",
    tech: "React JS and Bootstrap in the frontend.",
    year: "2023",
  },
  {
    name: "Remindee - To do list",
    link: "https://remindee.netlify.app/",
    description:
      "Remindee, a to-do list is a simple but effective tool for managing tasks and staying organized. It's a list of things you need to do or want to do, typically organized in order of priority or due date.",
    tech: "Bootstrap and JavaScript.",
    year: "2022",
  },
  {
    name: "Daily Mint - A news website",
    link: "https://github.com/Subhadip4521/DailyMint",
    description:
      "In a fast-paced world where information is currency and staying updated is a daily necessity, 'Daily Mint' emerges as your go-to destination for news that's as crisp, insightful, and invigorating as a fresh sprig of mint.",
    tech: "Bootstrap, JavaScript and News API.",
    year: "2022",
  },
];

export default projects;
